import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestResponse } from "../model/dto/RequestResponse";
import { PreIroned } from "../model/PreIroned";
import { PreIronedDetail } from "../model/PreIronedDetail";
import { PreIronedFailure } from "../model/PreIronedFailure";

@Injectable()
export class PreIronedFacade {

    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetInventorySummary(initialDate, finalDate, storeId: string): Observable<RequestResponse<any>> {
        let params = new HttpParams();
        params = params.append('initialDate', initialDate);
        params = params.append('finalDate', finalDate);
        params = params.append('storeId', storeId)

        return this._httpClient.get<RequestResponse<PreIroned[]>>(this._urlBase + 'api/PreIroned/GetSummary', { params: params });
    }

    GetInventoryDetails(inFile: any): Observable<RequestResponse<any>> {
        
        let body = JSON.stringify(inFile);

        return this._httpClient.post<RequestResponse<PreIronedDetail>>(this._urlBase + 'api/PreIroned/GetDetails', body, {
            headers: new HttpHeaders({'Content-Type':  'application/json'})
        });
    }

    GetInventoryFailures(storeId: any): Observable<RequestResponse<any>> {
        let params = new HttpParams();

        params = params.append('storeId', storeId);

        return this._httpClient.get<RequestResponse<PreIronedFailure>>(this._urlBase + 'api/PreIroned/GetFailures', { params: params });
    }

    GetInventoryToDownload(storeId: any): Observable<RequestResponse<any>> {
        let params = new HttpParams();

        params = params.append('storeId', storeId);

        return this._httpClient.get<RequestResponse<PreIronedDetail>>(this._urlBase + 'api/PreIroned/ToDownload', { params: params });
    }

}